/**
 * Return an array of objects sorted by key
 * Else return the array as it is
 * @param arr array of objects which should have the key
 * @param key a key to sort objects at
 * @returns
 */
export const sortArrayofObjectsByKey = (arr: any, key: any) => {
  try {
    return Array.isArray(arr) && key ? arr.sort(({ [key]: a }, { [key]: b }) => b - a) : arr;
  } catch (error: any) {
    console.log(error && error.message);
  }
};
